import { FC, memo, ReactNode } from "react";
import clsx from "clsx";
import styles from "./ExploreBanner.module.css";
import { GradientButton } from "components/GradientButton";
import { ArrowDown } from "assets/svgs";

const ExploreBanner: FC = () => {
  return (
    <div className={clsx(styles.root, "f-center")}>
      <img className={styles.left} src="/images/hackathon/left_banner.png" />

      <div className={styles.center}>
        <h1>
          Explore <br /> <strong>Hackathons</strong>
        </h1>
        <p>Join One and Start Building</p>
        <a href="#list-hkt">
          <GradientButton size="large">Explore Now</GradientButton>
        </a>
        <ArrowDown />
      </div>
      <img className={styles.background} src="/images/hackathon/bg.png" />
      <img className={styles.right} src="/images/hackathon/right_banner.png" />
    </div>
  );
};

export default memo(ExploreBanner);
